import styled from 'styled-components';

export const CmsImageBlockImageOrFigureContainer = styled.div`
  margin: 0;
`;
